import createChangedCharacteristicEntry from '../helpers/createChangedCharacteristicEntry.js'
import isCharacteristicChanged from '../helpers/isCharacteristicChanged.js'
import isEmpty from '../helpers/isEmpty.js'
//------------------------------
// track characteristic changes
//------------------------------
export default function trackCharacteristicChanges({
  pfx,
  character,
  original_chars,
  changed_chars,
}) {
  //
  console.log('-----------------------')
  console.log('IN trackCharacteristicChanges')

  console.log('pfx = ' + pfx)
  // console.log('character = ', character)
  // console.log('original_chars = ', original_chars)
  // console.log('changed_chars = ', changed_chars)
  // console.log('-----------------------')
  //---------------------
  // check args received
  //---------------------
  if (
    isEmpty(pfx) ||
    isEmpty(character) ||
    isEmpty(original_chars) ||
    changed_chars === undefined
  ) {
    return []
  }
  //---------------------------
  // find char in change array
  //---------------------------
  let idx = changed_chars.findIndex((c) => c.name === pfx)
  //------------------------------
  // char already in change array
  //------------------------------
  if (idx !== -1) {
    // console.log('1. CHARACTERISTIC ALREADY IN CHANGED ARRAY: ' + pfx)
    // check if values changed (could have reverted back to originals)
    let char_changed = isCharacteristicChanged(pfx, original_chars, character)
    // console.log('char_changed 1 = ' + char_changed)

    // value not original
    if (char_changed) {
      // console.log('2. CHAR VAL CHANGED: ' + pfx)
      // update characteristic entry
      changed_chars[idx].payload.rolled = character[pfx + '_rolled']
      changed_chars[idx].payload.improvs_tot = character[pfx + '_improvs_tot']
      // console.log('changed_chars 2 = ', changed_chars)
      // value is original - remove from array
    } else {
      // console.log('3. CHARACTERISTIC NOT CHANGED: ' + pfx)
      changed_chars.splice(idx, 1)
      // console.log('changed_chars 3 = ', changed_chars)
    }
    //--------------------------
    // char NOT in change array
    //--------------------------
  } else {
    // console.log('4. CHARACTERISTIC NOT IN CHANGED ARRAY: ' + pfx)
    //-------------------------------------------
    // changed - create characteristic change entry
    //----------------------------------------------
    let char_changed_parm = createChangedCharacteristicEntry(pfx, character)
    //-------------
    // add to array
    //--------------
    changed_chars.push(char_changed_parm)
    // console.log('changed_chars 4 = ', changed_chars)
  }
  return changed_chars
}
